export const phpToJsBranch = (branch) => {
  return {
    callGroupId: branch["call_group_id"],
    codecId: branch.codecs.map((item) => { return item.id }),
    pickupGroupId: branch.pickup_groups.map((item) => { return item.id }),
    number: branch.number,
    nat: branch.nat.id,
    port: branch.port,
    callLimit: branch["call_limit"],
    routeGroupId: branch["route_group_id"],
    dtmf: branch.dtmf.id,
    qualify: branch.qualify ? true : false,
    name: branch.branch_users.name,
    company: branch.branch_users.company,
    email: branch.branch_users.email,
    password: "",
    secret: "",
    password_blocked: branch.branch_users.password_blocked,
    user_occulted: branch.branch_users.user_occulted,
    externalNumber: branch.external_number,
  }
}

export const branch = {
  companyId: "",
  pabxId: "",
  callGroupId: "",
  codecId: [1, 2, 3],
  pickupGroupId: [],
  number: "",
  nat: 4,
  port: "5060",
  callLimit: "1",
  routeGroupId: "",
  dtmf: 1,
  qualify: true,
  name: "",
  email: "",
  company: "",
  password: "",
  secret: "",
  password_blocked: null,
  user_occulted: null,
  externalNumber: "",
  validate: {
    companyId: {
      message: "",
      isInvalid: false
    },
    company_id: {
      message: "",
      isInvalid: false
    },
    name: {
      message: "",
      isInvalid: false
    },
    company: {
      message: "",
      isInvalid: false
    },
    nat: {
      message: "",
      isInvalid: false
    },
    routeGroupId: {
      message: "",
      isInvalid: false
    },
    number: {
      message: "",
      isInvalid: false
    },
    port: {
      message: "",
      isInvalid: false
    },
    callLimit: {
      message: "",
      isInvalid: false
    },
    dtmf: {
      message: "",
      isInvalid: false
    },
    codecId: {
      message: "",
      isInvalid: false
    },
    callGroupId: {
      message: "",
      isInvalid: false
    },
    pickupGroupId: {
      message: "",
      isInvalid: false
    },
    email: {
      message: "",
      isInvalid: false
    },
    password: {
      message: "",
      isInvalid: false
    },
    secret: {
      message: "",
      isInvalid: false
    },
    user_occulted:{
      message: "",
      isInvalid: false
    },
    password_blocked: {
      message: "",
      isInvalid: false
    },
    externalNumber: {
      message: "",
      isInvalid: false
    },
    pabxId: {
      message: "",
      isInvalid: false
    },
    natId: {
      message: "",
      isInvalid: false
    },
    qualify: {
      message: "",
      isInvalid: false
    },
    phone: {
      message: "",
      isInvalid: false
    }
  },
}
